import { render } from "./NewTitlePageToolModal.vue?vue&type=template&id=b8972f22"
import script from "./NewTitlePageToolModal.vue?vue&type=script&lang=js"
export * from "./NewTitlePageToolModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__